import ForgotPasswordComponent from "./ForgotPasswordComponent";

export default ForgotPasswordComponent;
